<div class="bl-error-modal">
    <p>We don't deliver to your area</p>
</div>